import { Box, Button, Divider, Grid, IconButton, Modal, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { FieldValoration } from './FieldValoration';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { unSelectValorationStartup } from '../../../../store/startupValoration/startupValorationSlice';
import { editStartupValoration } from '../../../helpers/startupValoration';
import { DateInput } from '../../DateInput';
import { NumberInput } from '../../NumberInput';
import { style } from '../../../../helpers/editStyle';

export const EditStartupValoration = ({setHidden, setReloadData}) => {

    const { t } = useTranslation('global');
    const {dataToAction} = useSelector(state => state.startupValoration)
    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm(dataToAction);

    const { participationValuation, valuationDate, startupName } = formValues;


    const handleCancel = () => {
        reset()
        dispatch(unSelectValorationStartup())
        setHidden(false)
    }
    const onSubmit = (e) => {
        e.preventDefault();
        const {startup, startupName ,...formData} = formValues
        editStartupValoration(formData, t('startupHeaders.successMsgEdit'), t('startupHeaders.errorMsg'))
        setReloadData(prevState => !prevState)
        setHidden(false)
    }
 
  return (
    <>
            <Modal
                open={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 9999 }}
            >
                <Box sx={style}>
                    <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                        <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('valorationStartup.editValoration')}</Typography>
                        <IconButton color='primary' onClick={handleCancel}>
                            <CloseRoundedIcon />
                        </IconButton>
                    </Stack>
                    <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                        <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px',paddingRight:'20px' }}>

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} padding='0 5px'>
                                    <FieldValoration name={startupName} title='startupName' handleInputChange={handleInputChange} disabled={true}/>
                                </Grid>
                            </Grid>

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <DateInput name={valuationDate} title='valuationDate' handleInputChange={handleInputChange} required={true}/>
                                </Grid>
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <NumberInput name={participationValuation} title='participationValuation' handleInputChange={handleInputChange} required={true}/>
                                </Grid>
                            </Grid>

                        </Stack>

                        <Stack sx={{ heigth: '80px' }}>
                            <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                            <Grid container direction='row' width='100%' >
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                                </Grid>
                                <Grid item xs={12} md={6} padding='0 5px'>
                                    <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                                </Grid>
                            </Grid>
                        </Stack>
                    </form>

                </Box>
            </Modal>
        </>
  )
}